import { render, staticRenderFns } from "./DownloadForm.vue?vue&type=template&id=49a08fc6&"
import script from "./DownloadForm.vue?vue&type=script&lang=js&"
export * from "./DownloadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports